/* tslint:disable */
 
import { ActionInfo } from './action-info';
import { AnonymousViewOption } from './anonymous-view-option';
import { ApplicationSharing } from './application-sharing';
import { AuthenticatedViewOption } from './authenticated-view-option';
import { DashboardConfiguration } from './dashboard-configuration';
import { DataEntrySource } from './data-entry-source';
import { DataViewFilterFirstConfigurationDto } from './data-view-filter-first-configuration-dto';
import { DataViewHelp } from './data-view-help';
import { DataViewQrCodeConfiguration } from './data-view-qr-code-configuration';
import { DataViewScreenOrderItem } from './data-view-screen-order-item';
import { DataViewSystemButton } from './data-view-system-button';
import { DisplayViewConfiguration } from './display-view-configuration';
import { EditDataViewConfiguration } from './edit-data-view-configuration';
import { EntriesDataViewConfiguration } from './entries-data-view-configuration';
import { ExecutionPlan } from './execution-plan';
import { GenericViewDisplayConfig } from './generic-view-display-config';
import { Icon } from './icon';
import { LocalizedValue } from './localized-value';
import { NullableLocalizedValue } from './nullable-localized-value';
import { NullableReferenceProperty } from './nullable-reference-property';
import { RedirectionRule } from './redirection-rule';
import { RedirectionRuleRedirectConfig } from './redirection-rule-redirect-config';
import { SideBarConfig } from './side-bar-config';
import { ViewDisplayTemplate } from './view-display-template';
import { ViewRelation } from './view-relation';
import { ViewSourceOptions } from './view-source-options';

/**
 * (tsType: Omit<EndUserViewDto, >, schemaOptions: { includeRelations: undefined, exclude: [] })
 */
export class EndUserViewDto {
  anonymous?: null | AnonymousViewOption;
  authenticated?: null | AuthenticatedViewOption;
  creationInfo?: ActionInfo;
  dashboardConfiguration?: null | DashboardConfiguration;
  dataEntity: string;
  dataSource: DataEntrySource;
  defaultViewTemplate?: ViewDisplayTemplate;
  description?: null | NullableLocalizedValue;
  displayConfig?: null | GenericViewDisplayConfig;
  displayOrder?: number;
  domain?: null | NullableReferenceProperty;
  editConfiguration: EditDataViewConfiguration;
  entriesConfiguration: EntriesDataViewConfiguration;
  executionPlan?: ExecutionPlan;
  fields: Array<string>;
  filterFirstConfigDto?: null | DataViewFilterFirstConfigurationDto;
  help?: null | DataViewHelp;
  icon?: null | Icon;
  id?: string;
  implicitType?: 0 | 1 | 2 | 3;
  isImplicit?: boolean;
  isPinned?: boolean;
  /** @deprecated */isPublic?: boolean;
  isPublished?: boolean;
  module?: string;
  name: LocalizedValue;
  qrCode?: DataViewQrCodeConfiguration;
  redirection?: RedirectionRuleRedirectConfig;
  redirectionRules?: Array<RedirectionRule>;
  relations?: Array<ViewRelation>;
  screen?: 0 | 1 | 2 | 3;
  screenOrder?: Array<null | DataViewScreenOrderItem>;
  sharing: ApplicationSharing;
  sideBarConfig?: null | SideBarConfig;
  sourceOptions?: ViewSourceOptions;
  specificationVersion: number;
  systemButtons?: Array<DataViewSystemButton>;
  systemButtonsOrder?: Array<string>;
  uiAttributes?: null | {
};
  updateIdentifier: string;
  updateInfo?: ActionInfo;
  viewConfiguration: DisplayViewConfiguration;
}
